import { useAsyncAtom } from '@service-initiation/shared-utils-jotai';

import { availableStoresAsyncAtom } from '../atoms';

export const useAvailableStoresAsyncAtom = (calcNextAvailability?: boolean) =>
  useAsyncAtom(availableStoresAsyncAtom(calcNextAvailability));
